import { queryClient } from "~Shared/config/reactQueryConfig"
import { CacheEnum } from "../consts"

export const invalidateOposList = () => queryClient.invalidateQueries({ queryKey: [CacheEnum.EXPENSES_OPOS_LIST] })

export const invalidateOposTotals = () => queryClient.invalidateQueries({ queryKey: [CacheEnum.EXPENSES_OPOS_TOTALS] })
